import { render, staticRenderFns } from "./SectionCards.vue?vue&type=template&id=03e39324&scoped=true&"
var script = {}
import style0 from "./SectionCards.vue?vue&type=style&index=0&id=03e39324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e39324",
  null
  
)

export default component.exports